import { useMutation } from '@tanstack/react-query'

import { QUERIES } from '@/enums/queries'

import { invalidateLoadUserDetails } from '../users/useLoadUsers'
import {
  updateTeamConfig,
  UpdateTeamConfigProps,
} from './services/updateTeamConfig'

export const useUpdateTeamConfig = () => {
  const mutation = useMutation({
    mutationKey: [QUERIES.TEAM.UPDATE],
    mutationFn: async (data: UpdateTeamConfigProps) =>
      await updateTeamConfig(data),
    onSuccess: async () => await invalidateLoadUserDetails(),
  })

  const updateTeamConfigReq = async (data: UpdateTeamConfigProps) => {
    return mutation.mutateAsync(data)
  }

  return {
    updateTeamConfig: updateTeamConfigReq,
    ...mutation,
  }
}
